var cifYe = ["300 200", "<g fill='none'><path fill='#FFF' d='M0 0h300v200H0z'/><path fill='#CE1126' d='M0 0h300v66.667H0z'/><path fill='#000' d='M0 133.333h300V200H0z'/></g>"];

export { cifYe };

